import { createStyles, makeStyles, MenuItem, Select } from "@material-ui/core";
import { Language as LanguageIcon } from "@material-ui/icons";
import * as React from "react";
import { FC } from "react";
import { Language, LanguageLabels } from "../../../data/constants";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      color: theme.palette.primary.contrastText,
    },
    selectIcon: {
      color: theme.palette.primary.contrastText,
    },
    languageIcon: {
      marginRight: "0.5rem",
    },
  })
);

interface ILanguageSelectProps {
  language: Language;
  onChangeLanguage: (language: Language) => void;
}

export const LanguageSelect: FC<ILanguageSelectProps> = ({ language, onChangeLanguage }) => {
  const styles = useStyles({});

  return (
    <>
      <LanguageIcon className={styles.languageIcon} />
      <Select
        disableUnderline
        value={language}
        classes={{
          root: styles.root,
          icon: styles.selectIcon,
        }}
      >
        {Object.keys(Language).map((languageKey) => {
          const language = Language[languageKey as Language];
          return (
            <MenuItem key={language} value={language} onClick={() => onChangeLanguage(language)}>
              {LanguageLabels[language]}
            </MenuItem>
          );
        })}
      </Select>
    </>
  );
};
